<!-- /src/components/common/Sidebar/Filters.vue -->
<template>
  <div class="filters">
    <ul v-if="filters.length > 0 && showFilters" class="filters__items">
      <li
        class="filters__items__item"
        v-for="filter in filters"
        v-if="conditions(filter)"
        :key="filter.key"
      >
        <FilterItem :filter="filter" />
      </li>
    </ul>
  </div>
</template>

<script>
import FilterItem from '@/components/common/Sidebar/Filter'
import resizeMixin from '@/mixins/resizeMixin'


export default {
  props: {
    headline: {
      required: false,
      type: String,
    },
    sessionType: {
      required: false,
      type: String,
    },
    postType: {
      required: false,
      type: String,
    },
  },
  data() {
    return {
      screen: {
        width: 0,
      },
      isMobile: false,
      showFilters: true,
      filters: [
        {
          type: 'select',
          key: 'type',
          label: 'Content Type',
          postTypes: ['all', 'bookmarks', 'resources'],
          options: [
            {
              id: 'session',
              name: 'Sessions',
            },
            {
              id: 'course',
              name: 'Courses',
            },
            {
              id: 'relationships',
              name: 'Relationships',
            },
            {
              id: 'documents',
              name: 'Documents',
            },
          ],
        },
        {
          type: 'select',
          key: 'session_type',
          label: 'Media Type',
          postTypes: ['all', 'sessions', 'resources'],
          options: [
            {
              id: 'video',
              name: 'Video',
            },
            {
              id: 'audio',
              name: 'Audio',
            },
            {
              id: 'email',
              name: 'E-mail',
            },
            {
              id: 'downloads',
              name: 'Downloads',
            },
            {
              id: 'article',
              name: 'Article',
            },
          ],
        },
        {
          type: 'select',
          key: 'origin',
          label: 'Origin',
          postTypes: ['all', 'sessions', 'resources'],
          includeInputFilter: this.$store.getters['taxies/getAll']('origin').length > 9,
          options: this.$store.getters['taxies/getAll']('origin'),
        },
        {
          type: 'select',
          key: 'verticals',
          label: 'Vertical',
          postTypes: [
            'all',
            'courses',
            'sessions',
            'bookmarks',
            'resources',
            'relationships',
          ],
          includeInputFilter: this.$store.getters['taxies/getAll']('verticals').length > 9,
          options: this.$store.getters['taxies/getAll']('verticals'),
        },
        {
          type: 'select',
          key: 'deal_types',
          label: 'Deal Type',
          postTypes: [
            'all',
            'courses',
            'sessions',
            'resources',
          ],
          includeInputFilter: this.$store.getters['taxies/getAll']('deal_types').length > 9,
          options: this.$store.getters['taxies/getAll']('deal_types'),
        },
        {
          type: 'select',
          key: 'deal-phases',
          label: 'Deal Phase',
          postTypes: [
            'all',
            'courses',
            'sessions',
            'resources',
          ],
          includeInputFilter: this.$store.getters['taxies/getAll']('deal-phases').length > 9,
          options: this.$store.getters['taxies/getAll']('deal-phases'),
        },
        // {
        //   type: 'select',
        //   key: 'services',
        //   label: 'Services',
        //   postTypes: ['all'],
        //   includeInputFilter: this.$store.getters['taxies/getAll']('services').length > 9,
        //   options: this.$store.getters['taxies/getAll']('services'),
        // },
        {
          type: 'select',
          key: 'industries',
          label: 'Industry',
          postTypes: ['all', 'relationships'],
          includeInputFilter: this.$store.getters['taxies/getAll']('industries').length > 9,
          options: this.$store.getters['taxies/getAll']('industries'),
        },
        {
          type: 'select',
          key: 'geographies',
          label: 'Geography',
          postTypes: ['all', 'relationships'],
          includeInputFilter: this.$store.getters['taxies/getAll']('geographies').length > 9,
          options: this.$store.getters['taxies/getAll']('geographies'),
        },
        {
          type: 'select',
          key: 'authors',
          label: 'Author',
          includeInputFilter: true,
          postTypes: [
            'all',
            'courses',
            'sessions',
            'resources',
          ],
          includeInputFilter: this.$store.getters['taxies/getAll']('authors').length > 9,
          options: this.$store.getters['taxies/getAll']('authors'),
        },
      ],
    }
  },
  computed: {
    filterElements() {

    }
  },

  components: {
    FilterItem,
  },
  methods: {
    handleResize() {
        // this.showFilters = !this.isMobile
    },

    conditions(option) {
      const { query } = this.$route
      switch (option.key) {
        case 'geographies':
        case 'industries':
          return query.type == 'relationships' || this.postType == 'relationships'
        case 'scripture_references':
        case 'bible_topics':
          return query.type == 'bible-studies' || this.postType == 'bible-studies'
        case 'origin':
        case 'verticals':
        case 'deal_types':
        case 'deal-phases':
          return !(query.type == 'bible-studies' || query.type == 'relationships')
        default:
          return true
      }
    },
  },

  mixins: [resizeMixin],

  created() {
    if (this.$route.name === 'search') {
      this.filters = this.filters.filter(filter => {
        return filter.key == 'search' ? false : true
      })
    }
    this.filters = this.filters.filter(filter => {
      return typeof filter.postTypes == 'undefined'
        ? true
        : filter.postTypes.includes(this.postType)
    })
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style scoped>
.filters {
  &__header {
    margin: 0;
    margin-bottom: 1rem;
    font-size: 1.7rem;
    line-height: 1;
    color: var(--brandPrimary);

    &__container {
      display: grid;
      
      grid-gap: 0.5rem;
      align-items: center;

      @media (--phone) {
        grid-template-columns: 1fr auto;
      }
    }
  }

  &__items {
    margin: 0;
    display: grid;

    grid-gap: 0.75rem;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  &__mobile {
    @media (--tablet--horizontal) {
      display: none;
    }
    font-size: 0.7em;
  }
}
</style>
